module.exports = __webpack_public_path__ + "static/media/ground.cb062682.png";